<template>
  <v-dialog v-model="dialogState" persistent max-width="600px">
    <v-card>
      <v-toolbar color="accent" fixed>
        <v-toolbar-title>
          <v-icon left class="mt-n1">{{ actionIcon }}</v-icon>
          {{ dialogTitle }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-3">
        <h3>{{ confirmationText }}</h3>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closePopup">
          <v-icon class="mr-3">mdi-close</v-icon>
          {{ $vuetify.lang.t("$vuetify.action.cancel") }}
        </v-btn>
        <v-btn
          :loading="isSubmitting"
          :disabled="!action"
          @click="removeGln"
        >
          <v-icon class="mr-3">{{ actionIcon }}</v-icon>
          {{ actionLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "@/services/api";
import { getGlnAction } from "@/helpers/gln";

export default {
  props: {
    removeGlnPopup: {
      type: Boolean,
      default: false,
    },
    gln: {
      type: Object,
      default: null,
    },
  },
  data: function() {
    return {
      dialogState: false,
      isSubmitting: false,
    };
  },
  watch: {
    removeGlnPopup(newVal) {
      this.dialogState = newVal;
    },
  },
  computed: {
    action() {
      return getGlnAction(this.gln);
    },
    actionLabel() {
      return this.action
        ? this.$vuetify.lang.t(`$vuetify.action.${this.action.key}`)
        : "";
    },
    actionIcon() {
      return this.action ? this.action.icon : "mdi-delete";
    },
    dialogTitle() {
      return this.action
        ? this.$vuetify.lang.t(`$vuetify.manager.${this.action.key}_gln`)
        : "";
    },
    confirmationText() {
      return this.action
        ? this.$vuetify.lang.t(`$vuetify.action.${this.action.key}_confirm`)
        : "";
    },
  },
  methods: {
    closePopup() {
      this.dialogState = false;
      this.$emit("closeRemoveGlnPopup");
    },
    removeGln() {
      if (!this.action || !this.gln.id) {
        return;
      }

      this.isSubmitting = true;
      const request = this.action.nextStatus
        ? Api.gln("update", { id: this.gln.id, status: this.action.nextStatus })
        : Api.gln("delete", this.gln.id);

      request
        .then(({ data }) => {
          this.$toast.ok(this.$vuetify.lang.t("$vuetify.action.update_success"));
          this.$emit("closeRemoveGlnPopup");
          this.$emit("reload", data);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
